<template>
<div>
  <v-simple-table dense>
    <template v-slot:default>
        <thead>
          <tr class="heading">
            <td width="5%">#</td>
            <td width="40%">کالا</td>
            <td width="30%">مقدار</td>
            <td width="25%">توضیحات</td>
          </tr>
        </thead>
        <tbody>
          <tr class="item" v-for="(item, index) in firstItem" :key="item.row_id || index">
            <td>{{ index + 1 }}</td>
            <td><MyProductsUnits v-model="item.product"/></td>
            <td><MyFloat v-model="item.lending_value" :nodense="true" @blur="valueBlur(item)" /></td>
            <td><MyComment label=" " v-model="item.comment" /></td>
          </tr>
        </tbody>
      </template>
  </v-simple-table>
</div>
</template>

<script>
import MyProductsUnits from '../../components/MyProductsUnits.vue'
import MyFloat from '../../components/MyFloat.vue'
import MyComment from '../../components/MyComment.vue'

export default {
  name: 'MyLendingTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    valueBlur: {
      type: Function,
      required: true
    },
  },
  computed: {
    // فقط اولین آیتم را برمی‌گرداند تا v-if حذف شود
    firstItem() {
      return this.items.slice(0, 1)
    }
  },
  components: {
    MyProductsUnits,
    MyFloat,
    MyComment,
  },
}
</script>
